import { render } from "./DefaultColor.vue?vue&type=template&id=3868d7ae&scoped=true"
import script from "./DefaultColor.vue?vue&type=script&lang=js"
export * from "./DefaultColor.vue?vue&type=script&lang=js"

import "./DefaultColor.vue?vue&type=style&index=0&id=3868d7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3868d7ae"]])

export default __exports__